//import '@fortawesome/fontawesome-free/css/all.min.css'
//import 'bootstrap-css-only/css/bootstrap.min.css'

import { createApp } from 'vue'
import App from './App.vue'
import store from "./store";
import VueGtag from "vue-gtag";
import clientConfig from '/src/config/client.js';
import LifetimeIframeControl from '/src/config/LifetimeIframeControl.js'
import LifetimeHelpers from '/src/config/LifetimeHelpers.js'

createApp(App)
  .use(store)
  .use(VueGtag, {
    appName: 'Lifetime Contributions Calculator',
    pageTrackerScreenviewEnabled: true,
    config: {
      id: clientConfig.analytics.gacode,
      cookie_prefix: 'cc',
      cookie_flags: 'SameSite=None;Secure',
      params: {
        send_page_view: false,
        debug_mode: true
      }
    }
  })  
  .use(LifetimeIframeControl, {
    divId: "ccApp",
    clientConfig: clientConfig
  })
  .use(LifetimeHelpers, {
    clientConfig: clientConfig
  })
  .mount('#ccApp');
